export default "__VITE_ASSET__CpSOUWq___";